<template>
  <app-modal modal-id="fund-modal"
             modal-size="default"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_fund") : $t("add_fund") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/funds`">
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("title") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="text"
                  :placeholder="$t('enter_title')"
                  name="name"
                  v-model="formData.name"
                  :error-message="$errorMessage(errors, 'name')"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("museum") }}</label>
            </div>
            <div class="col-sm-7">
				
				<app-input v-model="formData.museum_id"
							           :error-message="$errorMessage(errors, 'museum_id')"
							           :list="museumList"
						    			:placeholder="$t('choose_museum')"
							           list-value-field='name'
							           type="select"/>
			
            </div>
          </div>
        </div> 
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("lead_group") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="search-select"
                  list-value-field="name"
                  :list="fundTypeList"
                  :placeholder="$t('choose_an_lead_group')"
                  v-model="formData.fund_type_id"
                  :error-message="$errorMessage(errors, 'fund_type_id')"
              />
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("years") }}</label>
            </div>
            <div class="col-3">
							<app-input v-model="formData.year_on"
							           :error-message="$errorMessage(errors, 'year_on')"
										   :placeholder="$t('year_on')"
							           type="text"/>
						</div>
						<div class="col-1"></div>
						<div class="col-3">
							<app-input v-model="formData.year_off"
							           :error-message="$errorMessage(errors, 'year_off')"
										   :placeholder="$t('year_off')"
							           type="text"/>
						</div>
          </div>
        </div>
		<div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("cond") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="select"
                  list-value-field="name"
                  :list="CondList"
                  :placeholder="$t('choose_cond')"
                  v-model="formData.cond"
                  :error-message="$errorMessage(errors, 'cond')"
              />
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("storage") }}</label>
            </div>
            <div class="col-sm-7">
				
				<app-input v-model="formData.inrest_id"
							           :error-message="$errorMessage(errors, 'inrest_id')"
							           :list="storageList"
						    			:placeholder="$t('choose')" 
							           list-value-field='name'
							           type="select"/>
			
            </div>
          </div>
        </div>  
		  <template>
				<div class="form-group mb-3">
					<div class="row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('zal_name') }}</label>
						<div class="col-sm-7">
							<app-input v-model="formData.zal_id"
							           :error-message="$errorMessage(errors, 'zal_id')"
							           :list="zalList"
									   :placeholder="$t('choose')"
							           list-value-field='name'
							           type="select"/>
						</div>
					</div>
				</div>

				</template>
				<template >
				<div class="form-group mb-3">
					<div class="row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('organization') }}</label>
						<div class="col-sm-7">
						
							<app-input v-model="formData.org"
							           :error-message="$errorMessage(errors, 'org')"
							           :list="organizationList"
							           list-value-field='name'
										    :placeholder="$t('choose_org')"
							           type="search-select"/>
						</div>

					</div>
				</div>
				</template>
				<template>
				<div class="form-group mb-3">
					<div class="row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('contact') }}</label>
						<div class="col-sm-7">
							<app-input v-model="formData.who"
							           :error-message="$errorMessage(errors, 'who')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
						</div>

					</div>
				</div>
				</template>
		  <div class="form-group mb-3">
					<div class="row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('restorer_id') }}</label>
						<div class="col-sm-7">
							
							<app-input v-model="formData.restorer_id"
							           :error-message="$errorMessage(errors, 'restorer_id')"
							           :list="restorerList"
									   :placeholder="$t('choose')"
							           list-value-field='name'
							           type="select"/>
						</div>

					</div>
				</div>
		  
		  
		  
		  
		  
		<template v-if="addMoreDetails">
          <h6 class="pb-3 pt-3">{{ $t("fund_more_details") }}</h6>
          <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('country_buy') }}</label>
              </div>
              <div class="col-sm-7">
                <app-input
                    type="search-select"
                    list-value-field="name"
                    :list="countryList"
                    :placeholder="$t('choose_a_country')"
                    v-model="formData.country_buy"
                />
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('date_buy') }}</label>
              </div>
              <div class="col-sm-7">
                <app-input
                				v-model="formData.date_buy"
                				:placeholder="$t('choose_a_date')"
								:popover-position="'top-start'"
								type="date"
              				/>
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('price_s') }}</label>
              </div>
              <div class="col-sm-7">
               <app-input v-model="formData.price_s"
							           :error-message="$errorMessage(errors, 'price_s')"
										    :placeholder="$t('enter_price_s')"
							           type="text"/>
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('type_owners') }}</label>
              </div>
              <div class="col-sm-7">
               <app-input
                  type="select"
                  list-value-field="name"
                  :list="OwList"
                  :placeholder="$t('choose_type_owners')"
                  v-model="formData.type_owners"
              />
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('country_made') }}</label>
              </div>
              <div class="col-sm-7">
                <app-input
                    type="search-select"
                    list-value-field="name"
                    :list="countryList"
                    :placeholder="$t('choose_a_country')"
                    v-model="formData.country_made"
                />
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('size') }}</label>
              </div>
              <div class="col-sm-7">
                <app-input v-model="formData.size"
							           :error-message="$errorMessage(errors, 'size')"
										    :placeholder="$t('enter_size')"
							           type="text"/>
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('designer') }}</label>
              </div>
              <div class="col-sm-7">
                <app-input v-model="formData.designer"
							           :error-message="$errorMessage(errors, 'designer')"
										    :placeholder="$t('enter_designer')"
							           type="text"/>
              </div>
            </div>
          </div>
		  <div class="form-group">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ $t('material') }}</label>
              </div>
              <div class="col-sm-7">
                <app-input v-model="formData.material"
							           :error-message="$errorMessage(errors, 'material')"
										    :placeholder="$t('enter_material')"
							           type="text"/>
              </div>
            </div>
          </div>
        </template>
		<div class="form-group" v-else>
          <div class="row">
            <div class="col-sm-5">

            </div>
            <div class="col-sm-7">
              <a href
                 @click.prevent="addMore()">{{ $t("add_fund_more") }}</a>
            </div>
          </div>
        </div>






        

        <template v-if="customFields.length && customFieldDataLoaded">
          <h6 class="pb-3 pt-3">{{ $t("custom_fields") }}</h6>
          <div class="form-group" v-for="field in customFields">
            <div class="row">
              <div class="mb-0 col-sm-5 d-flex align-items-center">
                <label>{{ field.name }}</label>
              </div>
              <div class="col-md-7">
                <template v-if="field.custom_field_type.name === 'text'">
                  <app-input
                    type="text"
                    :id="field.name"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'textarea'">
                  <app-input
                    type="textarea"
                    :id="field.name"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'radio'">
                  <app-input
                    type="radio"
                    :radio-checkbox-name="field.name"
                    :list="generateInputList(field)"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'checkbox'">
                  <app-input
                    type="checkbox"
                    :radio-checkbox-name="field.name"
                    :list="generateInputList(field)"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'select'">
                  <app-input
                    type="select"
                    :list="generateInputList(field)"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'number'">
                  <app-input
                    type="number"
                    v-model="customFieldValue[field.name]"
                  />
                </template>
                <template v-if="field.custom_field_type.name === 'date'">
                  <app-input type="date" v-model="customFieldValue[field.name]"/>
                </template>
              </div>
            </div>
          </div>
        </template>
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {getAllCustomFields} from "@app/Mixins/Global/CustomFieldMixin";
import {mapGetters} from "vuex";

export default {
  name: "FundModal",
  mixins: [FormSubmitMixin, getAllCustomFields],
  data() {
    return {
      isOrganizationModalActive: false,
      addMoreDetails: false,
      dataLoaded: false,
      countryList: [],
      formData: {owner_id: user.id},
      addEditData: {},
      customFieldValue:[],
	  CondList: [
	  		 	{ id: "1", name: "1",},
				{ id: "2", name: "2",},
				{ id: "3", name: "3",},
				{ id: "4", name: "4",},
				{ id: "5", name: "5",},
				{ id: "6", name: "6",},
				{ id: "7", name: "7",},
				{ id: "8", name: "8",},
				{ id: "9", name: "9",},
				{ id: "10", name: "10",},

	  		],
		OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
      organizations: [
        {
          pivot: {
            job_title: "",
            organization_id: "",
          },
        },
      ],
      phone: [
        {
          value: "",
          type_id: "",
        },
      ],
      emails: [
        {
          value: "",
          type_id: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      ownerList: "getOwner",
      museumList: "getMuseum",
		
      zalList: "getZal",
      peopleList: "getPerson",
      restorerList: "getRestorer",
      storageList: "getInrest",
		

      organizationList: "getOrganization",
      phoneEmailTypeList: "phoneEmailType",
      fundTypeList: "contfundType",
    }),

  },
  methods: {
    addMore(){
      this.addMoreDetails = true;
    },
    phoneAdd(index) {
      this.phone.push({value: "", type_id: ""});
    },
    phoneRemove(index) {
      this.phone.splice(index, 1);
    },
    OrgAndJobAdd(index) {
      this.organizations.push({
        pivot: {
          job_title: "",
          organization_id: "",
        },
      });
    },
    OrgAndJobRemove(index) {
      this.organizations.splice(index, 1);
    },
    emailAdd(index) {
      this.emails.push({value: "", type_id: ""});
    },
    emailRemove(index) {
      this.emails.splice(index, 1);
    },
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
      let customData = []
      this.customFields.map((el) => {
        if (this.customFieldValue[el.name]) {
          let item = {
            value:
                el.custom_field_type.name == "checkbox"
                    ? el.meta.split(",").filter((e, i) => {
                      if (
                          this.customFieldValue[el.name].includes(String(i)) ||
                          this.customFieldValue[el.name].includes(i)
                      ) {
                        return e;
                      }
                    })
                    : el.custom_field_type.name == "select" ||
                    el.custom_field_type.name == "radio"
                    ? el.meta.split(",").find((e, i) => {
                      return i == Number(this.customFieldValue[el.name]);
                    })
                    : this.customFieldValue[el.name],
            custom_field_id: el.id,
          };
          customData.push(item);
        }
      });

      this.addEditData.customs = customData;

      this.addEditData.phone = this.phone.map((v, i) => {
        return {
          value: v.value,
          type_id: v.type_id,
        };
      });
      this.addEditData.email = this.emails.map((v, i) => {
        return {
          value: v.value,
          type_id: v.type_id,
        };
      });


      this.addEditData.name = this.formData.name;
		
      this.addEditData.museum_id = this.formData.museum_id;
	  this.addEditData.cond = this.formData.cond;
	  this.addEditData.year_on = this.formData.year_on;
	  this.addEditData.year_off = this.formData.year_off;
	  this.addEditData.material = this.formData.material;
		this.addEditData.designer = this.formData.designer;
		this.addEditData.country_made = this.formData.country_made;
		this.addEditData.country_buy = this.formData.country_buy;
		this.addEditData.date_buy = this.formData.date_buy ? moment(this.formData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;
		this.addEditData.type_owners = this.formData.type_owners;
		this.addEditData.size = this.formData.size;
		this.addEditData.price_s = this.formData.price_s;
		
		
		
		this.addEditData.inrest_id = this.formData.inrest_id;
		this.addEditData.restorer_id = this.formData.restorer_id;
		this.addEditData.who = this.formData.who;
		this.addEditData.org = this.formData.org;
		this.addEditData.zal_id = this.formData.zal_id;
		
		
      this.addEditData.fund_type_id = this.formData.fund_type_id;
      this.addEditData.owner_id = this.formData.owner_id;
      this.addEditData.country_id = this.formData.country_id;
      this.addEditData.address = this.formData.address;
      this.addEditData.area = this.formData.area;
      this.addEditData.city = this.formData.city;
      this.addEditData.state = this.formData.state;
      this.addEditData.zip_code = this.formData.zip_code;
      this.addEditData.organizationData = this.organizations.map((v, i) => {
        return {
          job_title: v.pivot.job_title,
          organization_id: v.pivot.organization_id,
        };
      });
      this.save(this.addEditData);
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      if (this.formData.country ||
        this.formData.area ||
        this.formData.city ||
        this.formData.state ||
        this.formData.zip_code ||
        this.formData.address){
        this.addAddressDetails = true;
      }
      if (this.formData.phone.length) {
        this.phone = this.formData.phone;
      }
      if (this.formData.email.length) {
        this.emails = this.formData.email;
      }
      if (this.formData.organizations.length) {
        this.organizations = this.formData.organizations;
      }
    },
    openModal() {
      this.$emit("openOrgModal");
    },
    getCountry(){
      this.axiosGet("crm/country").then((res) => {
        this.countryList = res.data;
      });
    }
  },
  mounted() {
    this.getCountry();
    this.$store.dispatch("phoneEmailType");
    this.$store.dispatch("getOwner");

    this.$store.dispatch("getMuseum");
	  
    this.$store.dispatch("getZal");
    this.$store.dispatch("getPerson");
    this.$store.dispatch("getInrest");
    this.$store.dispatch("getRestorer");
	  
    this.$store.dispatch("getOrganization");
    this.$store.dispatch("contfundType");
    this.getAllCustomFields("fund");
    $("#organization-modal").on("hidden.bs.modal", () => {
      this.isOrganizationModalActive = false;
    });
  },
};
</script>
